import {post} from 'aws-amplify/api';
import type {DocumentType} from '@aws-amplify/core/internals/utils';
import {Command, type PostMethod} from '../../Command';
import type {UpdateNotificationsSettingsResponse} from '../../../dto/settings/UpdateNotificationsSettingsResponse';

export interface UpdateNotificationsSettingsCommandInput {
  marketingEmails?: boolean;
  refreshTokenExpiration?: boolean;
  extensionPing?: boolean;
  successfulPost?: boolean;
  failedPost?: boolean;
  proofreadingPost?: boolean;
}

export class UpdateNotificationsSettingsCommand extends Command<PostMethod, UpdateNotificationsSettingsResponse> {
  constructor({
    marketingEmails,
    refreshTokenExpiration,
    extensionPing,
    successfulPost,
    failedPost,
    proofreadingPost,
  }: UpdateNotificationsSettingsCommandInput) {
    const postBody: DocumentType = {};
    if (marketingEmails !== undefined) {
      postBody.marketingEmails = marketingEmails;
    }
    if (refreshTokenExpiration !== undefined) {
      postBody.refreshTokenExpiration = refreshTokenExpiration;
    }
    if (extensionPing !== undefined) {
      postBody.extensionPing = extensionPing;
    }
    if (successfulPost !== undefined) {
      postBody.successfulPost = successfulPost;
    }
    if (failedPost !== undefined) {
      postBody.failedPost = failedPost;
    }
    if (proofreadingPost !== undefined) {
      postBody.proofreadingPost = proofreadingPost;
    }
    super(post, {
      path: `/settings/notifications`,
      options: {
        body: postBody,
      },
    });
  }

  async deserialize(output: ReturnType<typeof post>): Promise<UpdateNotificationsSettingsResponse> {
    const {body} = await output.response;
    return await (body.json() as unknown as Promise<UpdateNotificationsSettingsResponse>);
  }
}
